// UK-Summary-Totals: delegates to ukFinalExport (single source with CSV export)

import { buildUkFinalExport } from "./ukFinalExport.js";

/** @deprecated Use buildUkFinalExport — kept as alias for callers. */
export function buildUkTaxSummaryFromDataset(dataset = {}, year, options = {}) {
  const result = buildUkFinalExport(dataset, year, options);
  return result?.summary || null;
}

/**
 * UK-Summary für UI: ausschließlich aus finalen Export-Zeilen (gleiche Quelle wie SA108-CSV).
 */
export function resolveUkSummaryForDisplay(dataset = {}, year, options = {}) {
  const exportResult = buildUkFinalExport(dataset, year, options);
  if (!exportResult?.summary) {
    return dataset?.ukTaxSummary || null;
  }

  return {
    ...(dataset?.ukTaxSummary || {}),
    ...exportResult.summary,
    sectionBreakdown: exportResult.sectionBreakdown,
    _ukFinalExport: exportResult,
    source: "uk_final_export_rows",
  };
}
